export const SECONDARY_REQUEST = "SECONDARY_REQUEST";
export const SECONDARY_UPDATE = "SECONDARY_UPDATE";
export const SECONDARY_UPDATED = "SECONDARY_UPDATED";
export const SECONDARY_DELETE = "SECONDARY_DELETE";
export const SECONDARY_CREATE = "SECONDARY_CREATE";
export const SECONDARY_SUCCESS = "SECONDARY_SUCCESS";
export const SECONDARY_ERROR = "SECONDARY_ERROR";
export const SECONDARY_LOADED = "SECONDARY_LOADED";
